import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="relative overflow-hidden border-t border-brand-500/10 bg-gradient-to-b from-brand-50/50 to-white dark:border-brand-300/10 dark:from-brand-950/20 dark:to-zinc-950">
      <div aria-hidden className="pointer-events-none absolute -bottom-40 -left-20 h-72 w-72 rounded-full bg-brand-400/15 blur-3xl dark:bg-brand-700/25" />
      <div aria-hidden className="pointer-events-none absolute -right-20 -top-40 h-72 w-72 rounded-full bg-brand-300/15 blur-3xl dark:bg-brand-700/20" />
      <div className="relative z-10 mx-auto flex max-w-6xl flex-col items-center gap-4 px-6 py-10">
        <nav className="flex items-center gap-6" aria-label="Legal">
          <a
            href="/about"
            className="text-xs font-semibold uppercase tracking-[0.08em] text-zinc-500 transition hover:text-brand-700 dark:text-zinc-400 dark:hover:text-brand-300"
          >
            {t('footer.about', 'About')}
          </a>
          <span className="h-4 w-px bg-brand-500/25" aria-hidden />
          <a
            href="/terms"
            className="text-xs font-semibold uppercase tracking-[0.08em] text-zinc-500 transition hover:text-brand-700 dark:text-zinc-400 dark:hover:text-brand-300"
          >
            {t('footer.terms')}
          </a>
          <span className="h-4 w-px bg-brand-500/25" aria-hidden />
          <a
            href="/privacy"
            className="text-xs font-semibold uppercase tracking-[0.08em] text-zinc-500 transition hover:text-brand-700 dark:text-zinc-400 dark:hover:text-brand-300"
          >
            {t('footer.privacy')}
          </a>
        </nav>
        <p className="text-xs tracking-wide text-zinc-400 dark:text-zinc-500">
            {t('footer.copyright', { year: new Date().getFullYear() })}
        </p>
        <p className="max-w-xl text-center text-[11px] leading-5 tracking-wide text-zinc-400/80 dark:text-zinc-600">
            {t('footer.disclaimer')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
